module.exports = __webpack_public_path__ + "static/media/17.0bfac4af.jpg";